export function optionalProjectId(projectId: number | undefined): { projectId: number } | Record<string, never> {
  return projectId !== undefined ? { projectId } : {}
}
